import { render, staticRenderFns } from "./NewExpensePage.vue?vue&type=template&id=342e4d12&scoped=true"
import script from "./NewExpensePage.vue?vue&type=script&lang=js"
export * from "./NewExpensePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e4d12",
  null
  
)

export default component.exports